export const MINESCOUNT = 40
export const FIELDH = 16
export const FIELDW = 16
export const MAXTIME = 40 * 60
